export default function Council2019Entries() {
    return (
        <table id="filetable">
                                {/*Start Table*/}
                                <tr>
                                  <th>Meeting Date</th>
                                  <th>Minutes</th>
                                  <th>Agenda</th>
                                </tr>
                                {/*Start File*/}
                                <tr>
                                  <td>12-16-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-12-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>12-10-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-12-10-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>11-12-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-11-12-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>11-07-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-11-07-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>10-21-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-10-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>10-08-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-10-08-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>09-16-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-09-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>09-10-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-09-10-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>08-19-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-08-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>08-13-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-08-13-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>07-15-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-07-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>07-07-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-07-09-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>06-17-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-06-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>05-20-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-05-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>05-14-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-05-14-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>04-15-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-04-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>04-09-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-04-09-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>03-18-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-03-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>03-12-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-03-12-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>02-19-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-02-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>02-12-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-02-12-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>01-22-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-01-22-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>01-08-2019</td>
                                  <td>
                                    <a href="../docs/council/minutes/2019/2019-01-08-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                              </table>
    )
}